
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33 6.239A51.462 51.462 0 0020 4.76 51.451 51.451 0 007 6.239C3.02 7.33 1 8.824 1 10.681V34.25a.992.992 0 00.99.99h36.019a.992.992 0 00.991-.99V10.681c0-1.857-2.02-3.351-6-4.442zM24.218 28.2v5.06h-3.232V28.2zm-5.213 0v5.06h-3.223V28.2zm5.914-19.384V6.929c.7.055 1.382.122 2.044.2v1.88a54.632 54.632 0 00-2.044-.193zm4.025.455V7.4c.711.114 1.395.243 2.044.385v1.851a39.147 39.147 0 00-2.044-.365zm-24.153 1.57V9.126a15.465 15.465 0 012.046-.776v1.811a20.588 20.588 0 00-2.046.68zm4.024-1.164V7.829a37.143 37.143 0 012.043-.395v1.868c-.708.112-1.392.237-2.043.375zm4.024-.646v-1.88c.661-.08 1.345-.149 2.044-.207l-.005 1.888c-.691.056-1.378.122-2.039.199zm4.024-.324V6.816a62.61 62.61 0 012.046-.066v1.893c-.684.011-1.37.032-2.046.064zm4.031-.067V6.747c.688.01 1.372.03 2.045.06V8.7a62.78 62.78 0 00-2.045-.06zm4.314 17.576H14.791a.992.992 0 00-.989.991v6.053H2.981V22.2c0-.291.36-.7.964-1.087a13.33 13.33 0 013.581-1.443A49.422 49.422 0 0120 18.261a49.408 49.408 0 0112.473 1.409 13.384 13.384 0 013.584 1.444c.6.39.963.8.963 1.087V33.26H26.2v-6.053a.992.992 0 00-.992-.991zM20 16.28a51.418 51.418 0 00-13 1.48 15.417 15.417 0 00-4.023 1.619v-4.825c0-.291.36-.7.963-1.088a13.425 13.425 0 013.582-1.443A49.46 49.46 0 0120 10.615a49.452 49.452 0 0112.473 1.408 13.443 13.443 0 013.584 1.443c.6.391.963.8.963 1.088v4.825A15.44 15.44 0 0033 17.76a51.43 51.43 0 00-13-1.48zm12.968-6.174V8.291a16.146 16.146 0 012.044.745v1.727a21.887 21.887 0 00-2.014-.649z"}})])
          )
        }
      }
    